<template>
  <div class="place-details">
    <div class="header d-none d-sm-block">
      <FloatingLogo></FloatingLogo>
      <div
        class="header-slider"
        :style="`background-image: url(${headerBackgroundImageUrl})`">
      </div>
    </div>

    <div class="header mobile d-xs-block d-sm-none">
      <FloatingLogo></FloatingLogo>
      <div
        class="header-slider"
        :style="`background-image: url(${mobileHeaderBackgroundImageUrl})`"
      ></div>
    </div>

    <BackButton></BackButton>

    <div class="body">
      <div class="results-list boxed">
        <div v-if="this.$store.state.setPlaceDetailsLoading == true || this.$store.state.fetchedPlaceDetails == null" class="loading-container">
          <h1>Cargando Detalles</h1>
        </div>
        <div v-else class="details">
          <PlaceItemDetails
                  v-bind:place="this.$store.state.fetchedPlaceDetails"
          ></PlaceItemDetails>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>


<script>
  // @ is an alias to /src
  import ResultsHeader from "@/components/ResultsHeader.vue";
  import PlaceItemDetails from "../components/PlaceItemDetails";
  import Footer from "../components/Footer";
  import FloatingLogo from "../components/FloatingLogo";
  import BackButton from "../components/BackButton";

  export default {
    name: "Results",
    components: {
      BackButton,
      FloatingLogo,
      Footer,
      PlaceItemDetails
    },
    data() {
      return {
        headerBackgroundImageUrl: "",
        mobileHeaderBackgroundImageUrl: ""
      };
    },
    created () {
      this.routeChanged()
    },
    watch: {
      '$route.params.placeId': function () {
        this.routeChanged()
      },
      '$store.state.searchResults.items': function () {
        this.loadDetails();
      }
    },
    methods: {
      fetchDetails () {
        this.$store.dispatch({
          type: "action",
          actionType: this.$types.FETCH_PLACE_DETAILS,
          value: {
            placeId: this.$route.params.place
          }
        });
      },
      loadDetails() {
        this.$store.dispatch({
          type: "action",
          actionType: this.$types.LOAD_PLACE_DETAILS_FROM_CACHE,
          value: {
            placeId: this.$route.params.place
          }
        });
      },
      routeChanged: function() {
        this.headerBackgroundImageUrl = "";

        const selectedStateArr = this.$store.state.staticStates.filter(
                stateObj => stateObj.value !== null ? stateObj.value.id == this.$route.params.state : false
        );

        if (selectedStateArr.length < 1) {
          console.log("array.length < 1")
          this.goHome();
          return;
        }

        const selectedState = selectedStateArr[0].value;

        if (this.$route.params.stateName !== selectedState.slug) {
          console.log("param and slug don't match", this.$route.params.stateName, selectedState.slug)
          this.goHome();
          return;
        }

        const imageUrl = `${this.$constants.STATES_HEADER_BASE_URL}${selectedState.slug}${this.$constants.STATES_HEADER_EXT}`
        const mobileImageUrl = `${this.$constants.MOBILE_STATES_HEADER_BASE_URL}${selectedState.slug}${this.$constants.STATES_HEADER_EXT}`

        // console.log(imageUrl);

        this.headerBackgroundImageUrl = imageUrl;
        this.mobileHeaderBackgroundImageUrl = mobileImageUrl;

        this.fetchDetails();

      }
    }
  };
</script>
